<section *ngIf="(activeStepIndex$ | async) !== undefined">
  <div class="cx-nav"
    data-cy="mb-checkout-progress-bar">
    <ul class="cx-list flex-column flex-sm-row">
      <ng-container *ngFor="let step of steps$ | async; let i = index">
        <li
          data-cy="mb-checkout-step"
          class="cx-item"
          [class.active]="isActive(i)"
          [class.disabled]="isDisabled(i)"
        >
          <a
            [routerLink]="{ cxRoute: step.routeName } | cxUrl"
            class="cx-link"
            [class.active]="isActive(i)"
            [class.disabled]="isDisabled(i)"
            [tabindex]="getTabIndex(i)"
            [innerHTML]="step.name | cxTranslate
            "
          >
          </a>
        </li>
      </ng-container>
    </ul>
  </div>
</section>
